<template>
    <b-modal id="clinicDoctorSearch" :title="title" size="md" @show="fn_search">
        <div class="table_list">
            <ul class="search_filter">
                <li>
                    <p>{{ searchName }}</p>
                    <input type="text" :placeholder="`${searchName}을(를) 입력하세요`" class="form_control" v-model="doctor_nm" @keyup.enter="fn_search">
                    <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
                </li>
              <li>
                    <p>한의원명</p>
                    <input type="text" placeholder="한의원명을 입력하세요" class="form_control" v-model="clinic_nm" @keyup.enter="fn_search">
              </li>
            </ul>
            <div class="modal_table">
                <table class="list">
                    <thead>
                        <tr>
                            <th></th>
                            <th>No</th>
                            <th>회원아이디</th>
                            <th>회원명</th>
                            <th>한의원명</th>
                            <th>닉네임</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in clinicDoctorList" :key="index">
                        <td>
                            <div class="form_checkbox">
                                <input type="checkbox" :id="'checkbox'+index" name="checkbox" v-model="checkBox" :value="index" @change="fn_check">
                                <label :for="'checkbox'+index"></label>
                            </div>
                        </td>
                        <td><span>{{ index + 1 }}</span></td>
                        <td><span>{{ item.clinic_doctor_id }}</span></td>
                        <td><span>{{ item.doctor_nm }}</span></td>
                        <td><span>{{ item.clinic_nm }}</span></td>
                        <td><span>{{ item.nick_nm }}</span></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <template #modal-footer="{ ok }">        
            <b-button class="btn btn_md btn_gray" v-show="oneBtn" @click="fn_apply">{{ btnLeft }}</b-button>
            <b-button class="btn btn_md btn_deepblue" @click="fn_init(),ok()">{{ btnRight }}</b-button>
        </template>
    </b-modal>

</template>

<script>
    import axios from 'axios'


    export default {
        name: 'clinicDoctorSearch',
        props: {
            title: String,
            btnLeft: String,
            btnRight: String,
            searchName: String,
            searchData: String,
            oneBtn: Boolean,
            filter: Boolean,
        },
        data() {
            return {
                checkBox : [],
                clinicDoctorList : [],
                doctor_nm : this.searchData,
                clinic_nm : ''
            }
        },
        watch : {
          searchData(newValue) {
                console.log("변경 체크");
                //props 변경 여부 확인
                this.doctor_nm = newValue;

            }
        },
        methods : {
            fn_search(){

                let param = new Object();
                param.doctor_nm = this.doctor_nm;
                param.clinic_nm = this.clinic_nm;


              console.log("@@@@ param : %o",param);

                axios
                    .post("/api/admin/userMngt/getClinicDoctorInfo", param)
                    .then((res) => {
                        console.log("@@@@ dtl res : %o",res);
                        this.clinicDoctorList = res.data.clinicDoctorList;
                    })
                    .catch((err) => console.log(err));
                
            },
            fn_apply(){
                               
                if(this.checkBox.length == 0){
                    alert("체크된 회원이 없습니다.");
                }else if(this.checkBox.length > 1){
                    alert("한명만 선택해주세요");
                }else{                    
                    
                    let medObject = this.clinicDoctorList[this.checkBox[0]];
                    
                    //let medCode = this.medicineList[this.checkBox[0]].med_hrb_cd;
                    //let medName = this.medicineList[this.checkBox[0]].med_hrb_nm;
                    //let medHrbDtlSeq = this.medicineList[this.checkBox[0]].med_hrb_dtl_seq;
                    //let orgPlceNm = this.medicineList[this.checkBox[0]].org_plce_nm;


                    this.$emit('callback', medObject);

                    this.fn_init();
                    this.$bvModal.hide('clinicDoctorSearch');
                }                                        
            },
            fn_init(){
                this.clinicDoctorList = [];
                this.checkBox = [];
                this.doctor_nm = '';
                this.clinic_nm = '';
            },
            fn_check(){
                if(this.checkBox.length > 1){
                    this.checkBox.splice(0,1);
                }
            }
        }
    }
</script>
